
export const ADMIN_COURS_INITIATE_AJOUTER_CATEGORIE = 'ADMIN_COURS_INITIATE_AJOUTER_CATEGORIE';
export const ADMIN_COURS_AJOUTER_CATEGORIE_START = 'ADMIN_COURS_AJOUTER_CATEGORIE_START';
export const ADMIN_COURS_AJOUTER_CATEGORIE_SUCCESS = 'ADMIN_COURS_AJOUTER_CATEGORIE_SUCCESS';
export const ADMIN_COURS_AJOUTER_CATEGORIE_FAIL = 'ADMIN_COURS_AJOUTER_CATEGORIE_FAIL';
export const ADMIN_COURS_AJOUTER_CATEGORIE_RESET = 'ADMIN_COURS_AJOUTER_CATEGORIE_RESET';